// Owner Console: company, website, notifications, hiring (and, for White Knight owners,
// Ads & Offers, the referral programs and partner companies). The console asks for the
// password again, so the tour explains the lock first and only points at sections after that.
//
// Hiring here means employees and contractors (careers page → applicants → contracts).
// Service-provider companies apply on the provider application form and are reviewed
// under Submissions, which has its own tour.
const ownerConsole = {
  title: 'Owner Console',
  steps: ({ isPlatform, companyName }) => [
    {
      target: null,
      title: 'The Owner Console',
      body: `Everything about ${companyName} as a business: branding and documents, the services and prices customers see, memberships, every automated message, and hiring${isPlatform ? ', plus the White Knight-only programs (ads, referrals, partner companies)' : ''}. Owners only.`
    },
    {
      target: 'owner-lock',
      title: 'It locks itself',
      body: 'The console asks for your password again and stays unlocked for a while; the chip counts down. Lock now closes it on the spot. If the dialog is open, enter your password to carry on.',
      placement: 'left'
    },
    {
      target: 'owner-nav',
      title: 'Sections',
      body: `The list on the left is grouped: Company, Website, Notifications${isPlatform ? ', Partners' : ''}, Hiring${isPlatform ? ', Programs' : ''}. Each section opens in the space to the right.`,
      placement: 'right'
    },
    {
      target: 'owner-howitworks',
      title: 'How this works',
      body: 'Every section starts with this card: what the section controls, where the result shows up (portal, website, app, email) and what happens after you save. Collapse it once you know a section; it stays collapsed.',
      placement: 'bottom'
    },
    {
      target: 'owner-nav-company/setup',
      title: 'Try it: open Company setup',
      body: 'Click Company setup.',
      action: 'click',
      placement: 'right'
    },
    {
      target: 'owner-section',
      title: 'Company setup',
      body: 'Name, logo, colours, About text and reviews, the published documents (provider agreement, privacy policy, customer terms), provider requirements, social and app links. This is the same wizard you used at the start; come back to change anything.',
      placement: 'top'
    },
    {
      target: 'owner-nav-website/services',
      title: 'Try it: open Services & pricing',
      body: 'Click Services & pricing.',
      action: 'click',
      placement: 'right'
    },
    {
      target: 'owner-section',
      title: 'Services & pricing',
      body: 'Which services customers can order, the price of each by vehicle class and region, whether cash is accepted, and how each one is dispatched (nearest driver or a blast to everyone in range). Prices go live on your website and in the app within minutes.',
      placement: 'top'
    },
    {
      target: 'owner-nav-website/memberships',
      title: 'Memberships',
      body: 'The membership switch, the plans and their prices, and the introductory offer. Saving also updates Stripe.',
      placement: 'right'
    },
    {
      target: 'owner-nav-notifications/switchboard',
      title: 'Try it: open the Switchboard',
      body: 'Click Switchboard.',
      action: 'click',
      placement: 'right'
    },
    {
      target: 'owner-section',
      title: 'Every automated message',
      body: 'One switch per message (request received, driver assigned, on the way, arrived, complete, survey…) and per channel (text, email, phone push, portal bell), plus which roles get staff messages. Send a notification, next to it, writes a one-off message to staff or customers.',
      placement: 'top'
    },
    {
      target: 'owner-nav-hiring/postings',
      title: 'Hiring: employees and contractors',
      body: 'Job postings go on your careers page; people who apply for a job come in under Applicants with their résumé and skills assessment; contract templates are e-signed from the applicant panel.\n\nThis is separate from provider onboarding: towing and service companies that want to take your jobs fill in the provider application form and are reviewed under Submissions in the main menu.',
      placement: 'right'
    },
    {
      target: 'owner-nav-programs/knights',
      title: 'Programs',
      body: 'White Knight only: customer referrals (Knights) and provider referrals, the rewards, who referred whom, and recording payouts.',
      placement: 'right',
      when: () => isPlatform
    },
    {
      target: 'owner-nav-partners/companies',
      title: 'Partner companies',
      body: 'White Knight only: create a partner motor club, send its owner the setup link, suspend or reactivate it, switch demo mode, and act as that company for 30 minutes to see what they see.',
      placement: 'right',
      when: () => isPlatform
    },
    {
      target: null,
      title: 'That is the console',
      body: 'Each section\'s "How this works" card is the quick reference; the written help (? → Help & tutorials) goes deeper. Replay this tour from the ? button whenever you like.'
    }
  ]
};

export default ownerConsole;
